import { CheckCircleOutlined, HourglassOutlined, ToolOutlined, DeleteOutlined } from '@ant-design/icons';
import type { PaletteColor } from '@shipium-corp/shipium-ui-theme';

export enum ContextStatus {
  ACTIVE = 'Active',
  ARCHIVED = 'Archived',
  IDLE = 'Idle',
  INCOMPLETE = 'Incomplete',
}

export interface FulfillmentContextStatus {
  label: string;
  color: PaletteColor;
  icon: React.ReactNode;
}

export interface ContextStatusInput {
  archived: boolean;
  isValid: boolean;
  recentCarrierSelectionCount: number;
}

export const getContextStatus = (context: ContextStatusInput): FulfillmentContextStatus => {
  if (context.archived) {
    return {
      label: ContextStatus.ARCHIVED,
      color: 'Violet',
      icon: <DeleteOutlined />,
    };
  } else if (context.isValid) {
    if (context.recentCarrierSelectionCount === -1) {
      // Data not yet loaded, show idle state as fallback
      return {
        label: ContextStatus.IDLE,
        color: 'Blue',
        icon: <HourglassOutlined />,
      };
    } else if (context.recentCarrierSelectionCount > 0) {
      return {
        label: ContextStatus.ACTIVE,
        color: 'Teal',
        icon: <CheckCircleOutlined />,
      };
    } else {
      return {
        label: ContextStatus.IDLE,
        color: 'Blue',
        icon: <HourglassOutlined />,
      };
    }
  } else {
    return {
      label: ContextStatus.INCOMPLETE,
      color: 'Coral',
      icon: <ToolOutlined />,
    };
  }
};
